module.exports = __webpack_public_path__ + "img/08—01—01—Diagnostic information > Condensed.99eff1e2.jpg";